export default __webpack_public_path__ + "static/media/people-with-glowing-lightbulb.358746a5.svg";